function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { debounce } from '@cloud-sn/v-utils';
/* eslint-disable */

export default {
  props: {
    // height of each item
    size: {
      type: Number,
      required: true
    },
    // number of items should be shown
    remain: {
      type: Number,
      required: true
    },
    //  the virtual-list root element tag name
    rtag: {
      type: [String, Object],
      default: 'div'
    },
    // the virtual-list item wrapper element tag name,
    wtag: {
      type: [String, Object],
      default: 'div'
    },
    wclass: {
      type: String,
      default: ''
    },
    wstyle: {
      type: Object,
      default: undefined
    },
    wprops: {
      type: Object,
      default: undefined
    },
    wlisteners: {
      type: Object,
      default: undefined
    },
    // the initial scroll start index
    start: {
      type: Number,
      default: 0
    },
    // the initial scroll offset
    offset: {
      type: Number,
      default: 0
    },
    variable: [Function, Boolean],
    // unreached items count, not shown in virtual-list
    bench: Number,
    debounce: Number,
    totop: Function,
    tobottom: Function,
    onscroll: Function
  },
  created: function created() {
    var start = this.start >= this.remain ? this.start : 0;
    var keeps = this.remain + (this.bench || this.remain);
    this.delta = {
      start: start,
      // start index.
      end: start + keeps - 1,
      // end index.
      keeps: keeps,
      // nums keeping in real dom.
      total: 0,
      // all items count, update in filter.
      offsetAll: 0,
      // cache all the scrollable offset.
      paddingTop: 0,
      // container wrapper real padding-top.
      paddingBottom: 0,
      // container wrapper real padding-bottom.
      varCache: {},
      // object to cache variable index height and scroll offset.
      varAverSize: 0,
      // average/estimate item height before variable be calculated.
      varLastCalcIndex: 0 // last calculated variable height/offset index, always increase.

    };
  },
  watch: {
    size: function size() {
      this.alter = 'size';
    },
    remain: function remain() {
      this.alter = 'remain';
    },
    bench: function bench() {
      this.alter = 'bench';
    },
    start: function start() {
      this.alter = 'start';
    },
    offset: function offset() {
      this.alter = 'offset';
    }
  },
  methods: {
    onScroll: function onScroll(e) {
      var delta = this.delta;
      var offset = this.$refs.vsl.scrollTop;

      if (delta.total > delta.keeps) {
        this.updateZone(offset);
      } else {
        delta.end = delta.total - 1;
      }

      var offsetAll = delta.offsetAll;

      if (this.onscroll) {
        this.onscroll(e, {
          offset: offset,
          offsetAll: offsetAll,
          start: delta.start,
          end: delta.end
        });
      }

      if (!offset && delta.total) {
        this.triggerEvent('totop');
      }

      if (offset >= offsetAll) {
        this.triggerEvent('tobottom');
      }
    },
    // update render zone by scroll offset.
    updateZone: function updateZone(offset) {
      var overs = this.variable ? this.getVarOvers(offset) : Math.floor(offset / this.size);
      var delta = this.delta;
      var zone = this.getZone(overs);
      var bench = this.bench || this.remain; // for better performance, if scroll pass items within now bench, do not update.

      if (!zone.isLast && overs > delta.start && overs - delta.start <= bench) {
        return;
      }

      delta.end = zone.end;
      delta.start = zone.start;
      this.$forceUpdate();
    },
    // return the scroll passed items count in variable.
    getVarOvers: function getVarOvers(offset) {
      var low = 0;
      var middle = 0;
      var middleOffset = 0;
      var delta = this.delta;
      var high = delta.total;

      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        middleOffset = this.getVarOffset(middle); // calculate the average variable height at first binary search.

        if (!delta.varAverSize) {
          delta.varAverSize = Math.floor(middleOffset / middle);
        }

        if (middleOffset === offset) {
          return middle;
        } else if (middleOffset < offset) {
          low = middle + 1;
        } else if (middleOffset > offset) {
          high = middle - 1;
        }
      }

      return low > 0 ? --low : 0;
    },
    // return a variable scroll offset from given index.
    getVarOffset: function getVarOffset(index, nocache) {
      var delta = this.delta;
      var cache = delta.varCache[index];

      if (!nocache && cache) {
        return cache.offset;
      }

      var offset = 0;

      for (var i = 0; i < index; i++) {
        var size = this.getVarSize(i, nocache);
        delta.varCache[i] = {
          size: size,
          offset: offset
        };
        offset += size;
      }

      delta.varLastCalcIndex = Math.max(delta.varLastCalcIndex, index - 1);
      delta.varLastCalcIndex = Math.min(delta.varLastCalcIndex, delta.total - 1);
      return offset;
    },
    // return a variable size (height) from given index.
    getVarSize: function getVarSize(index, nocache) {
      var cache = this.delta.varCache[index];

      if (!nocache && cache) {
        return cache.size;
      }

      if (typeof this.variable === 'function') {
        return this.variable(index) || 0;
      } else {
        var slot = this.$slots.default[index];
        var style = slot && slot.data && slot.data.style;

        if (style && style.height) {
          var shm = style.height.match(/^(.*)px$/);
          return shm && +shm[1] || 0;
        }
      }

      return 0;
    },
    // return the variable paddingTop base current zone.
    // @todo: if set a large `start` before variable was calculated,
    // here will also case too much offset calculate when list is very large,
    // consider use estimate paddingTop in this case just like `getVarPaddingBottom`.
    getVarPaddingTop: function getVarPaddingTop() {
      return this.getVarOffset(this.delta.start);
    },
    // return the variable paddingBottom base current zone.
    getVarPaddingBottom: function getVarPaddingBottom() {
      var delta = this.delta;
      var last = delta.total - 1;

      if (delta.total - delta.end <= delta.keeps || delta.varLastCalcIndex === last) {
        return this.getVarOffset(last) - this.getVarOffset(delta.end);
      } else {
        // if unreached last zone or uncalculate real behind offset
        // return the estimate paddingBottom avoid too much calculate.
        return (delta.total - delta.end) * (delta.varAverSize || this.size);
      }
    },
    // return the variable all heights use to judge reach bottom.
    getVarAllHeight: function getVarAllHeight() {
      var delta = this.delta;

      if (delta.total - delta.end <= delta.keeps || delta.varLastCalcIndex === delta.total - 1) {
        return this.getVarOffset(delta.total);
      } else {
        return this.getVarOffset(delta.start) + (delta.total - delta.end) * (delta.varAverSize || this.size);
      }
    },
    // the ONLY ONE public method, allow the parent update variable by index.
    updateVariable: function updateVariable(index) {
      // clear/update all the offfsets and heights ahead of index.
      this.getVarOffset(index, true);
    },
    // return the right zone info base on `start/index`.
    getZone: function getZone(index) {
      var start, end;
      var delta = this.delta;
      index = parseInt(index, 10);
      index = Math.max(0, index);
      var lastStart = delta.total - delta.keeps;
      var isLast = index <= delta.total && index >= lastStart || index > delta.total;

      if (isLast) {
        end = delta.total - 1;
        start = Math.max(0, lastStart);
      } else {
        start = index;
        end = start + delta.keeps - 1;
      }

      return {
        end: end,
        start: start,
        isLast: isLast
      };
    },
    // trigger a props event on parent.
    triggerEvent: function triggerEvent(event) {
      if (this[event]) {
        this[event]();
      }
    },
    // set manual scroll top.
    setScrollTop: function setScrollTop(scrollTop) {
      this.$refs.vsl.scrollTop = scrollTop;
    },
    // filter the shown items base on `start` and `end`.
    filter: function filter() {
      var delta = this.delta;
      var slots = this.$slots.default;

      if (!slots) {
        slots = [];
        delta.start = 0;
      } // slots = recursiveSlots(slots);
      // console.log('slots');


      delta.total = slots.length;
      var paddingTop, paddingBottom, allHeight;
      var hasPadding = delta.total > delta.keeps;

      if (this.variable) {
        allHeight = this.getVarAllHeight();
        paddingTop = hasPadding ? this.getVarPaddingTop() : 0;
        paddingBottom = hasPadding ? this.getVarPaddingBottom() : 0;
      } else {
        allHeight = this.size * delta.total;
        paddingTop = this.size * (hasPadding ? delta.start : 0);
        paddingBottom = this.size * (hasPadding ? delta.total - delta.keeps : 0) - paddingTop;
      }

      delta.paddingTop = paddingTop;
      delta.paddingBottom = paddingBottom;
      delta.offsetAll = allHeight - this.size * this.remain;
      var targets = [];

      for (var i = delta.start; i <= delta.end; i++) {
        targets.push(slots[i]);
      }

      return targets;
    }
  },
  mounted: function mounted() {
    if (this.start) {
      var start = this.getZone(this.start).start;
      this.setScrollTop(this.variable ? this.getVarOffset(start) : start * this.size);
    } else if (this.offset) {
      this.setScrollTop(this.offset);
    }
  },
  // check if delta should update when prorps change.
  updated: function updated() {
    var delta = this.delta;
    delta.keeps = this.remain + (this.bench || this.remain);
    var calcstart = this.alter === 'start' ? this.start : delta.start;
    var zone = this.getZone(calcstart); // if start, size or offset change, update scroll position.

    if (~['start', 'size', 'offset'].indexOf(this.alter)) {
      this.$nextTick(this.setScrollTop.bind(this, this.alter === 'offset' ? this.offset : this.variable ? this.getVarOffset(zone.isLast ? delta.total : zone.start) : zone.isLast && delta.total - calcstart <= this.remain ? delta.total * this.size : calcstart * this.size));
    } // if points out difference, force update once again.


    if (calcstart !== zone.start || delta.end !== zone.end || this.alter) {
      this.alter = '';
      delta.end = zone.end;
      delta.start = zone.start;
      this.$forceUpdate();
    }
  },
  render: function render(h) {
    var list = this.filter();
    var delta = this.delta;
    var dbc = this.debounce;
    return h(this.rtag, {
      ref: 'vsl',
      style: {
        display: 'block',
        'overflow-y': 'auto',
        height: this.size * this.remain + 'px'
      },
      on: {
        '&scroll': dbc ? debounce(this.onScroll.bind(this), dbc) : this.onScroll
      }
    }, [h(this.wtag, {
      style: _objectSpread({}, this.wstyle, {
        display: 'block',
        'padding-top': delta.paddingTop + 'px',
        'padding-bottom': delta.paddingBottom + 'px'
      }),
      class: this.wclass,
      props: this.wprops,
      on: this.wlisteners
    }, list)]);
  }
};
/* eslint-enable */